module.exports = __webpack_public_path__ + "img/lczj-top-banner.3ba5078b.png";